import {
    AccordionButton,
    AccordionContent,
    AccordionIcon,
    AccordionTitle,
    AccordionWrapper,
} from "shared/components/data-display/accordion/Accordion.styles";
import React, { useState } from "react";

import PropTypes from "prop-types";

const Accordion = ({ accordionData = [], ...rest }) => {
    const [show, setShow] = useState(-1);
    const handleClick = (index) => {
        setShow(index === show ? -1 : index);
    };

    return (
        <>
            {accordionData.map((data, index) => (
                <AccordionButton
                    key={data.title ?? index}
                    onClick={() => handleClick(index)}
                    rest={rest}
                    type="button"
                >
                    <AccordionWrapper
                        hasNoBorder={data?.hasNoBorder}
                        hasNoPadding={data?.hasNoPadding}
                    >
                        <AccordionContent justify="space-between">
                            {data.title && (
                                <AccordionTitle
                                    variant="Headline_5"
                                    show={show === index}
                                >
                                    {data.title}
                                </AccordionTitle>
                            )}

                            <AccordionIcon
                                name={
                                    show === index ? "caret-up" : "caret-down"
                                }
                                show={show === index}
                            />
                        </AccordionContent>

                        {show === index && <>{data.children}</>}
                    </AccordionWrapper>
                </AccordionButton>
            ))}
        </>
    );
};

Accordion.propTypes = {
    accordionData: PropTypes.arrayOf(
        PropTypes.shape({
            title: PropTypes.string,
            children: PropTypes.node,
            hasNoBorder: PropTypes.bool,
            hasNoPadding: PropTypes.bool,
        })
    ),
};

export default Accordion;
